var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{staticClass:"input-get",attrs:{"type":"warning"},on:{"click":_vm.getCode}},[_vm._v(_vm._s(_vm.btnText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }